import { render, staticRenderFns } from "./DiffValue.vue?vue&type=template&id=23532f50&"
import script from "./DiffValue.vue?vue&type=script&lang=js&"
export * from "./DiffValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports